import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import socialBtns from "../../../db/socialBtns";
import copyIcon from "../../../assets/images/icons/copy-icon.svg";
import backArrow from "../../../assets/images/icons/arrow-left.svg";
import settings from "../../../assets/images/icons/setting-2.svg";
import notificationIcon from "../../../assets/images/icons/notification-bing.svg";
import { useTranslation } from "react-i18next";
import { $api } from "../../../api/api";
import { toastMsg } from "../../../utils/swal";
import QRCode from "../../../components/QRCode";
import { DEFAULT_IMAGES, PROFILE_TYPES } from "../../../constants/constants";
import { LoginContext } from "../../../utils/Auth";
import * as ProfileServices from "../../Profile/Service/ProfileService";
import MobileNavBar from "../../../components/MobileNavBar";
import NotificationMenu from "../../../components/NotificationMenu";
import { MainContext } from "../../../utils/MainContext";
import ProfileCard from "../../../components/ProfileCard";
import ProfilePhoneNumbersEdit from "../../Profile/View/components/ProfilePhoneNumbersEdit";

const ShareProfile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useContext(LoginContext);
  const { notificationCount } = useContext(MainContext);
  const [qrCode, setQrCode] = useState("");
  const [openMenu, setOpenMenu] = useState(false);

  const targetUsername = user?.username;
  const targetProfile = user?.profile;

  const [showPhonePrompt, setShowPhonePrompt] = useState(false);

  useEffect(() => {
    if (user) {
      const hasPhone =
        user?.profile?.phone_number ||
        (user?.profile?.phone_numbers &&
          user?.profile?.phone_numbers?.length > 0);
      if (!hasPhone) {
        setShowPhonePrompt(true);
      } else {
        setShowPhonePrompt(false);
      }
    }
  }, [user]);

  const userData = {
    username: targetUsername || "",
    profile_type: targetProfile?.subscription?.tier || "",
    avatar: targetProfile?.avatar || "",
    full_name: targetProfile?.full_name || "",
    background_image: targetProfile?.background_image || "",
    profession: {
      name: targetProfile?.profession?.name || "",
      description: targetProfile?.profession?.description || "",
    },
    bio: targetProfile?.bio || "",
    in_boxes_count: targetProfile?.in_boxes_count || 0,
    phone_number:
      targetProfile?.phone_number ||
      targetProfile?.phone_numbers?.[0]?.phone_number ||
      "",
  };

  useEffect(() => {
    if (targetUsername) {
      ProfileServices.profileFindByUsername(targetUsername)
        .then((res) => {
          if (res?.qr?.svg) {
            setQrCode(res.qr.svg);
          }
        })
        .catch(() => {});
    }
  }, [targetUsername, user]);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      return false;
    }
  };

  const handleCopyClick = () => {
    const url = `${window.location.origin}/shared-user/${userData.username}`;
    if (copyToClipboard(url)) {
      toastMsg(t("sharedUserCard.linkCopied"), "#00ff00", "#fff");
    } else {
      toastMsg(t("sharedUserCard.errorOnCopy"), "#ff0000", "#fff");
    }
  };

  return (
    <div className="container">
      <div className="shareHeader">
        <div className="leftSide">
          <div className="goBack" onClick={() => navigate(-1)}>
            <img src={backArrow} alt="back-arrow" />
          </div>
          <p>{t("dashboardHeader.share")}</p>
        </div>
        <div className="rightSide">
          <div className="areaIcons" onClick={() => setOpenMenu(!openMenu)}>
            {notificationCount > 0 && (
              <span className="notificationCount">{notificationCount}</span>
            )}
            <Link to={"#"}>
              <img src={notificationIcon} alt="notification-bing" />
            </Link>
          </div>
          <Link to={"/settings"}>
            <img src={settings} alt="settings-bing" />
          </Link>
        </div>
      </div>
      {showPhonePrompt ? (
        <div className="shareProfile" style={{ display: "block" }}>
          <div className="modalBox addPhone" style={{ width: "100%", maxWidth: "530px", margin: "0 auto", backgroundColor: "#fff", padding: "20px", borderRadius: "16px" }}>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#23272f",
                textAlign: "center",
                textWrap: "wrap",
                marginBottom: "20px",
              }}
            >
              {t("sharedUserCard.completeInfoPrompt")}
            </h3>
            <ProfilePhoneNumbersEdit
              profileData={user?.profile}
              setProfileData={() => {}}
              isProUser={user?.profile?.subscription?.tier !== PROFILE_TYPES.free}
              startInAddMode={true}
              askFullName={true}
              closeModal={() => setShowPhonePrompt(false)}
            />
          </div>
        </div>
      ) : (
        <div className="shareProfile">
          <ProfileCard
          disabled={true}
          hideButton={true}
          inBox={true}
          in_boxes_by_owner={false}
          data={userData}
          remove={() => {}}
          add={() => {}}
        />
        <div className="profileInfo">
          <div className="qrCode">
            <QRCode qrCodeData={qrCode} />
          </div>
          {false && (
            <ul className="shareSocial">
              {socialBtns.map((item) => (
                <li className="socialButton" key={item.id}>
                  <Link to={item.url} target="_blank">
                    <img src={item.icon} alt={item.title} />
                  </Link>
                </li>
              ))}
            </ul>
          )}
          <div className="link">
            <Link
              to={`${window.location.origin}/shared-user/${userData.username}`}
              className="sharedLink"
            >
              {window.location.origin.replace(
                window.location.protocol + "//",
                "",
              )}
              /<span>{userData.username}</span>
            </Link>
            <img
              src={copyIcon}
              alt="copy"
              className="copy"
              onClick={() => {
                handleCopyClick();
              }}
            />
          </div>
        </div>
        </div>
      )}
      <MobileNavBar />
      <NotificationMenu setOpenMenu={setOpenMenu} openMenu={openMenu} />
    </div>
  );
};

export default ShareProfile;
